import React from 'react'
import { connect } from 'react-redux'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { ProcessRow } from './ProcessRow'

const CommentHistory = props => {
  const { comments=[], attachment } = props
  const [showComment, setShowComment] = React.useState(true)
  return (
    comments.length === 0 ? null :
      <Card style={{ marginTop: '10px' }}>
        <CardHeader 
          title='Comment History'
          action={
            <IconButton aria-label='Expand' onClick={() => setShowComment(!showComment) }>
              {showComment ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          }
        />
        <Collapse in={showComment}>
          <CardContent>
            { 
              comments.map((item, i) => {
                let files = (attachment || []).filter(x => x.commentId === item.id)
                return <ProcessRow data={item} files={files} />
              })
            }
          </CardContent>
        </Collapse>
      </Card>
  )
}

const mapStateToProps = state => {}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CommentHistory)
